import { RootState } from 'store';

export const productionStateSelector = (state: RootState) => state.production;
